import { render, staticRenderFns } from "./Course.Registration.vue?vue&type=template&id=ecdc757a"
import script from "./Course.Registration.vue?vue&type=script&lang=js"
export * from "./Course.Registration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports